package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DragIndicatorW500Rounded: ImageVector
    get() {
        if (_dragIndicatorW500Rounded != null) {
            return _dragIndicatorW500Rounded!!
        }
        _dragIndicatorW500Rounded = Builder(name = "DragIndicatorW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(356.48f, 807.41f)
                quadToRelative(-34.61f, 0.0f, -59.25f, -24.64f)
                reflectiveQuadToRelative(-24.64f, -59.25f)
                quadToRelative(0.0f, -34.61f, 24.64f, -59.06f)
                quadTo(321.87f, 640.0f, 356.48f, 640.0f)
                reflectiveQuadToRelative(59.06f, 24.46f)
                quadTo(440.0f, 688.91f, 440.0f, 723.52f)
                reflectiveQuadToRelative(-24.46f, 59.25f)
                quadToRelative(-24.45f, 24.64f, -59.06f, 24.64f)
                close()
                moveTo(603.69f, 807.41f)
                quadToRelative(-34.54f, 0.0f, -59.11f, -24.64f)
                quadTo(520.0f, 758.13f, 520.0f, 723.52f)
                reflectiveQuadToRelative(24.55f, -59.06f)
                quadTo(569.11f, 640.0f, 603.59f, 640.0f)
                quadToRelative(34.58f, 0.0f, 59.2f, 24.46f)
                quadToRelative(24.62f, 24.45f, 24.62f, 59.06f)
                reflectiveQuadToRelative(-24.59f, 59.25f)
                quadToRelative(-24.59f, 24.64f, -59.13f, 24.64f)
                close()
                moveTo(356.48f, 563.59f)
                quadToRelative(-34.61f, 0.0f, -59.25f, -24.56f)
                quadToRelative(-24.64f, -24.55f, -24.64f, -59.03f)
                quadToRelative(0.0f, -34.67f, 24.64f, -59.13f)
                reflectiveQuadToRelative(59.25f, -24.46f)
                quadToRelative(34.61f, 0.0f, 59.06f, 24.46f)
                quadTo(440.0f, 445.33f, 440.0f, 479.88f)
                reflectiveQuadToRelative(-24.46f, 59.13f)
                quadToRelative(-24.45f, 24.58f, -59.06f, 24.58f)
                close()
                moveTo(603.69f, 563.59f)
                quadToRelative(-34.54f, 0.0f, -59.11f, -24.56f)
                quadTo(520.0f, 514.48f, 520.0f, 480.0f)
                quadToRelative(0.0f, -34.67f, 24.55f, -59.13f)
                quadToRelative(24.56f, -24.46f, 59.04f, -24.46f)
                quadToRelative(34.58f, 0.0f, 59.2f, 24.46f)
                quadToRelative(24.62f, 24.46f, 24.62f, 59.01f)
                reflectiveQuadToRelative(-24.59f, 59.13f)
                quadToRelative(-24.59f, 24.58f, -59.13f, 24.58f)
                close()
                moveTo(356.48f, 320.0f)
                quadToRelative(-34.61f, 0.0f, -59.25f, -24.55f)
                quadToRelative(-24.64f, -24.56f, -24.64f, -59.04f)
                quadToRelative(0.0f, -34.58f, 24.64f, -59.2f)
                quadToRelative(24.64f, -24.62f, 59.25f, -24.62f)
                reflectiveQuadToRelative(59.06f, 24.59f)
                quadTo(440.0f, 201.77f, 440.0f, 236.31f)
                quadToRelative(0.0f, 34.54f, -24.46f, 59.11f)
                quadTo(391.09f, 320.0f, 356.48f, 320.0f)
                close()
                moveTo(603.69f, 320.0f)
                quadToRelative(-34.54f, 0.0f, -59.11f, -24.55f)
                quadTo(520.0f, 270.89f, 520.0f, 236.41f)
                quadToRelative(0.0f, -34.58f, 24.55f, -59.2f)
                quadToRelative(24.56f, -24.62f, 59.04f, -24.62f)
                quadToRelative(34.58f, 0.0f, 59.2f, 24.59f)
                quadToRelative(24.62f, 24.59f, 24.62f, 59.13f)
                quadToRelative(0.0f, 34.54f, -24.59f, 59.11f)
                quadTo(638.23f, 320.0f, 603.69f, 320.0f)
                close()
            }
        }
        .build()
        return _dragIndicatorW500Rounded!!
    }

private var _dragIndicatorW500Rounded: ImageVector? = null
